import React, { useEffect, useState } from "react";
import styled from "styled-components"
import { Link } from "react-router-dom";
import { isMobile } from 'react-device-detect';

import { getAllShows } from "../shows"

const Shows = styled.div`
    display: ${isMobile ? "block":"flex"};

    a {
        display: ${isMobile ? "grid":"flex"};
        flex-direction: column;
        justify-content: space-between;
        grid-template-columns: 35% 65%;
        gap: ${isMobile ? 15:5}px;
        align-items: center;

        color: white;
        text-decoration: none;

        div {
            text-align:center;
            margin: 10px;

            &.date {
                color: orange;
            }
        }
    }
    a:hover {
        text-decoration: underline;
    }
`
const Heading = styled.h3`
    margin-bottom: 5px;
    text-align: center;
`

function ShowsListing(props) {
  const [shows, setShows] = useState(props.shows || getAllShows());

  return (
    <>
        <Heading>{props.heading || "2024-2025 Season"}</Heading>
        <div style={{
            display: "flex",
            justifyContent: "center",
        }}>
            <Shows>    
                {shows.map((show, index) => (
                    <Link key={index} to={show.url}>
                        <div>
                            <img src={show.poster} alt={show.title + " Poster"} width={100} />
                        </div>
                        <div>
                            {isMobile && 
                                <div>{show.title}</div>
                            }
                            <div className="date">{show.dateFormattedShort}</div>
                        </div>
                    </Link>
                ))} 
            </Shows>
        </div>
    </>
  );
}

export default ShowsListing;